import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import _ from 'lodash';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap'
import { NewOrdersCurrentWeekGrid, OrderSummaryGrid, ServiceThreadSpinner } from '.';
import { api, constants, helpers } from '../utils';

export default function SalesDashboardNewOrders(props) {
  const [data, setData] = useState();
  const [completedOrderDataSortDirection, setCompletedOrderDataSortDirection] = useState("asc");
  const [completedOrderDataSortField, setCompletedOrderDataSortField] = useState("DocumentDate");
  const [completedOrdersDisplayOption, setCompletedOrdersDisplayOption] = useState('today');
  const [loaded, setLoaded] = useState(false);
  const [newOrderDataSortDirection, setNewOrderDataSortDirection] = useState("asc");
  const [newOrderDataSortField, setNewOrderDataSortField] = useState("CustomerName");
  const [newOrdersDisplayOption, setNewOrdersDisplayOption] = useState('today');
  const [newPartOrderDataSortDirection, setNewPartOrderDataSortDirection] = useState("asc");
  const [newPartOrderDataSortField, setNewPartOrderDataSortField] = useState("CustomerName");
  const [newPartOrdersDisplayOption, setNewPartOrdersDisplayOption] = useState('today');
  const [salespersonId, setSalespersonId] = useState(props.salespersonId)
  const isWhse = false;

  useEffect(() => {
    if (props.salespersonId !== salespersonId) {
      setSalespersonId(props.salespersonId);
      setLoaded(false);
    }
    if (!loaded) {
      loadData(newOrdersDisplayOption, newPartOrdersDisplayOption, completedOrdersDisplayOption);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaded, props.salespersonId])

  function exportCompleteOrdersGrid() {
    api
      .postGetBlob("Sales/ExportCompletedOrdersGrid", {
        SalesPersonId: props.salespersonId,
        IsWarehouse: isWhse,
        CompletedOrdersDisplayOption: completedOrdersDisplayOption,
        CompletedOrderDataSortField: completedOrderDataSortField,
        CompletedOrderDataSortDirection: completedOrderDataSortDirection
      })
      .then(r => {
        if (r.data.success === false) {
          if (_.isString(r?.data?.message)) {
            toast.error(r?.data?.message);
          }
          return;
        }
        if (r.data) {
          const XLSX_FILENAME = salespersonId ? `${salespersonId}_Completed_Orders.xlsx` : `Completed_Orders.xlsx`
          helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
        } else {
          toast.error(r.message || "Error downloading report");
        }
      })
      .catch(api.catchHandler);
  }

  function exportNewOrdersGrid() {
    api
      .postGetBlob("Sales/ExportNewOrdersGrid", {
        SalesPersonId: props.salespersonId,
        IsWarehouse: isWhse,
        NewOrdersDisplayOption: newOrdersDisplayOption,
        NewOrderDataSortField: newOrderDataSortField,
        NewOrderDataSortDirection: newOrderDataSortDirection
      })
      .then(r => {
        if (r.data.success === false) {
          if (_.isString(r?.data?.message)) {
            toast.error(r?.data?.message);
          }
          return;
        }
        if (r.data) {
          const XLSX_FILENAME = salespersonId ? `${salespersonId}_New_Orders.xlsx` : `New_Orders.xlsx`
          helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
        } else {
          toast.error(r.message || "Error downloading report");
        }
      })
      .catch(api.catchHandler);
  }

  function exportPartOrdersGrid() {
    api
      .postGetBlob("Sales/ExportPartOrdersGrid", {
        SalesPersonId: props.salespersonId,
        IsWarehouse: isWhse,
        NewPartOrdersDisplayOption: newPartOrdersDisplayOption,
        NewPartOrderDataSortField: newPartOrderDataSortField,
        NewPartOrderDataSortDirection: newPartOrderDataSortDirection
      })
      .then(r => {
        if (r.data.success === false) {
          if (_.isString(r?.data?.message)) {
            toast.error(r?.data?.message);
          }
          return;
        }
        if (r.data) {
          const XLSX_FILENAME = salespersonId ? `${salespersonId}_New_Part_Orders.xlsx` : `New_Part_Orders.xlsx`
          helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
        } else {
          toast.error(r.message || "Error downloading report");
        }
      })
      .catch(api.catchHandler);
  }

  function loadData(newOrdersDisplayOption, newPartOrdersDisplayOption, completedOrdersDisplayOption) {
    api
      .post("Sales/LoadSalesDashboardNewOrders", {
        SalesPersonId: props.salespersonId,
        IsWarehouse: isWhse,
        NewOrdersDisplayOption: newOrdersDisplayOption,
        NewOrderDataSortField: newOrderDataSortField,
        NewOrderDataSortDirection: newOrderDataSortDirection,
        NewPartOrdersDisplayOption: newPartOrdersDisplayOption,
        NewPartOrderDataSortField: newPartOrderDataSortField,
        NewPartOrderDataSortDirection: newPartOrderDataSortDirection,
        CompletedOrdersDisplayOption: completedOrdersDisplayOption,
        CompletedOrderDataSortField: completedOrderDataSortField,
        CompletedOrderDataSortDirection: completedOrderDataSortDirection
      })
      .then(response => {
        if (response.data.success) {
          setData(response.data.newOrdersData)
        }
      })
      .catch(api.catchHandler)
      .finally(() => setLoaded(true));
  }

  function onChangeCompletedOrdersDisplayOption(option) {
    setCompletedOrdersDisplayOption(option);
    setLoaded(false);
  }

  function onChangeNewOrdersDisplayOption(option) {
    setNewOrdersDisplayOption(option);
    setLoaded(false);
  }

  function onChangeNewPartOrdersDisplayOption(option) {
    setNewPartOrdersDisplayOption(option);
    setLoaded(false);
  }

  function onCompletedOrderDataSortChange(field, direction) {
    if (field !== completedOrderDataSortField) {
      setCompletedOrderDataSortField(field);
      setCompletedOrderDataSortDirection("asc")
    } else {
      setCompletedOrderDataSortDirection(direction);
    }
    setLoaded(false);
  }

  function onNewOrderDataSortChange(field, direction) {
    if (field !== newOrderDataSortField) {
      setNewOrderDataSortField(field);
      setNewOrderDataSortDirection("asc")
    } else {
      setNewOrderDataSortDirection(direction);
    }
    setLoaded(false);
  }

  function onNewPartOrderDataSortChange(field, direction) {
    if (field !== newPartOrderDataSortField) {
      setNewPartOrderDataSortField(field);
      setNewPartOrderDataSortDirection("asc")
    } else {
      setNewPartOrderDataSortDirection(direction);
    }
    setLoaded(false);
  }

  return (
    <React.Fragment>
      <div className="mb-3">
        <span className="h2 me-2">New Orders</span>
      </div>
      <div className="mb-0">
        <span className="h5 me-2 text-muted">Order Summaries</span>
        <hr className="mt-0" />
      </div>
      <ServiceThreadSpinner on={!loaded}>
        <Row className="mb-3">
          <Col>
            {data && data.newOrderSummaryData
              ? <div>
                New Orders
                <OrderSummaryGrid
                  summaryData={data.newOrderSummaryData}
                />
              </div>
              : null
            }
          </Col>
          <Col>
            {data && data.completedOrderSummaryData
              ? <div>
                Completed Orders
                <OrderSummaryGrid
                  summaryData={data.completedOrderSummaryData}
                />
              </div>
              : null
            }
          </Col>
        </Row>

        <div>
          <span className="h5 me-2 text-muted">New Orders Current Week</span>
          <hr className="mt-0" />
        </div>
        {data && data.hasNewOrderData
          ? <Row className="mb-3">
            <Col>
              <div style={{ border: "1px solid #bbb", borderRadius: "10px", padding: "3px", width: "40%" }}>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio1"
                      checked={newOrdersDisplayOption  ===  'current_week'}
                      onChange={e => onChangeNewOrdersDisplayOption('current_week')}
                    /> Current Week
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio1"
                      checked={newOrdersDisplayOption  ===  'today'}
                      onChange={e => onChangeNewOrdersDisplayOption('today')}
                    /> Today
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio1"
                      checked={newOrdersDisplayOption  ===  'alerts'}
                      onChange={e => onChangeNewOrdersDisplayOption('alerts')}
                    /> Alerts
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio1"
                      checked={newOrdersDisplayOption  ===  'hide_grid'}
                      onChange={e => onChangeNewOrdersDisplayOption('hide_grid')}
                    /> Hide Data Grid
                  </Label>
                </FormGroup>
              </div>
              {data && data.newOrderData && data.newOrderData.length
                ? (<Row>
                    <Col>
                      <NewOrdersCurrentWeekGrid
                        data={data.newOrderData}
                        totalPrice={data.newOrderDataTotalPrice}
                        totalCost={data.newOrderDataTotalCost}
                        marginTotal={data.newOrderDataMarginTotal}
                        marginTotalDisplay={data.newOrderDataMarginTotalDisplay}
                        sortCallback={onNewOrderDataSortChange}
                        sortField={newOrderDataSortField}
                        sortDirection={newOrderDataSortDirection}
                      exportXlsxCallback={() => exportNewOrdersGrid()}
                      />
                    </Col>
                  </Row>)
                : null
              }
            </Col>
          </Row>
          : <span className="h5" style={{ color: "red" }}>No orders found</span>
        }
        <div>
          <span className="h5 me-2 text-muted">Machine Part Orders Current Week</span>
          <hr className="mt-0" />
        </div>
        {data && data.hasNewPartOrderData
          ? <Row className="mb-3">
            <Col>
              <div style={{ border: "1px solid #bbb", borderRadius: "10px", padding: "3px", width: "40%" }}>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio2"
                      checked={newPartOrdersDisplayOption  ===  'current_week'}
                      onChange={e => onChangeNewPartOrdersDisplayOption('current_week')}
                    /> Current Week
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio2"
                      checked={newPartOrdersDisplayOption  ===  'today'}
                      onChange={e => onChangeNewPartOrdersDisplayOption('today')}
                    /> Today
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio2"
                      checked={newPartOrdersDisplayOption  ===  'alerts'}
                      onChange={e => onChangeNewPartOrdersDisplayOption('alerts')}
                    /> Alerts
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio2"
                      checked={newPartOrdersDisplayOption  ===  'hide_grid'}
                      onChange={e => onChangeNewPartOrdersDisplayOption('hide_grid')}
                    /> Hide Data Grid
                  </Label>
                </FormGroup>
              </div>
              {data && data.newPartOrderData && data.newPartOrderData.length > 0
                ? <Row>
                  <Col>
                    <NewOrdersCurrentWeekGrid
                      data={data.newPartOrderData}
                      totalPrice={data.newPartOrderDataTotalPrice}
                      totalCost={data.newPartOrderDataTotalCost}
                      marginTotal={data.newPartOrderDataMarginTotal}
                      marginTotalDisplay={data.newPartOrderDataMarginTotalDisplay}
                      sortCallback={onNewPartOrderDataSortChange}
                      sortField={newPartOrderDataSortField}
                      sortDirection={newPartOrderDataSortDirection}
                      exportXlsxCallback={() => exportPartOrdersGrid()}
                    />
                  </Col>
                </Row>
                : null
              }
            </Col>
          </Row>
          : <Row className="mb-3">
            <Col>
              <span className="h5" style={{ color: "red" }}>No machine part orders found</span>
            </Col>
          </Row>
        }


        <div>
          <span className="h5 me-2 text-muted">Completed Orders Current Week</span>
          <hr className="mt-0" />
        </div>
        {data && data.hasCompletedOrderData
          ? <Row>
            <Col>
              <div style={{ border: "1px solid #bbb", borderRadius: "10px", padding: "3px", width: "40%" }}>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio3"
                      checked={completedOrdersDisplayOption  ===  'current_week'}
                      onChange={e => onChangeCompletedOrdersDisplayOption('current_week')}
                    /> Current Week
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio3"
                      checked={completedOrdersDisplayOption  ===  'today'}
                      onChange={e => onChangeCompletedOrdersDisplayOption('today')}
                    /> Today
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio3"
                      checked={completedOrdersDisplayOption  ===  'alerts'}
                      onChange={e => onChangeCompletedOrdersDisplayOption('alerts')}
                    /> Alerts
                  </Label>
                </FormGroup>
                <FormGroup check inline>
                  <Label check>
                    <Input
                      type="radio"
                      name="radio3"
                      checked={completedOrdersDisplayOption  ===  'hide_grid'}
                      onChange={e => onChangeCompletedOrdersDisplayOption('hide_grid')}
                    /> Hide Data Grid
                  </Label>
                </FormGroup>
              </div>
              {data && data.completedOrderData && data.completedOrderData.length > 0
                ? <Row className="mb-3">
                  <Col>
                    <NewOrdersCurrentWeekGrid
                      data={data.completedOrderData}
                      totalPrice={data.completedOrderDataTotalPrice}
                      totalCost={data.completedOrderDataTotalCost}
                      newOrderDataMarginTotal={data.completedOrderDataMarginTotal}
                      marginTotalDisplay={data.completedOrderDataMarginTotalDisplay}
                      sortCallback={onCompletedOrderDataSortChange}
                      sortField={completedOrderDataSortField}
                      sortDirection={completedOrderDataSortDirection}
                      isCompletedOrdersData={true}
                      exportXlsxCallback={() => exportCompleteOrdersGrid()}
                    />
                  </Col>
                </Row>
                : null
              }
            </Col>
          </Row>
          : <Row className="mb-3">
            <Col>
              <div className="h5" style={{ color: "red" }}>No completed orders found</div>
            </Col>
          </Row>
        }

      </ServiceThreadSpinner>
    </React.Fragment>
  )
}